import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { LegalDocument } from '../components/LegalDocument';
import { PRIVACY_EFFECTIVE_DATE, privacyPolicy } from '../data/privacyPolicy';
export function Privacy() {
  return <>
      <PageHeader title="Lightning Learn Privacy Policy" intro={`Effective ${PRIVACY_EFFECTIVE_DATE}`} data-id="element-451" data-mp="3b9w3fuvo2tk9" />
      {/* #website-analytics is linked from the consent card and Cookie choices. */}
      <LegalDocument blocks={privacyPolicy} idOverrides={{
      'Website analytics and cookies': 'website-analytics'
    }} data-id="element-452" data-mp="3k7oiqz1e217n" />
    </>;
}